import { localStorage } from 'dibs-browser-storage';
import includes from 'lodash.includes';
import pick from 'lodash.pick';

import User from '../global/models/User';

const MAX_PROMPT_INFO_COUNT = 2; //max number of times an extant user should be prompted to provide information on login
const COUNT_TOKEN = 'info_prompt_count'; //key to local storage itemm that stores the number of times the user has been prompted to provide user info upon login
const COMPLETED_TOKEN = 'info_prompt_completed'; //key to local storage item that is set to true if user completes user info flow
const CUTOFF_DATE = new Date('07/21/16'); //user that registered before this date need not be prompted to complete user info modal

const SUSPECTED_TRADE_STATUS = 'SUSPECTED';

const canApplyForTrade = (tradeStatus) => {
    const { TRADE_STATUSES } = User;
    const canApplyStatuses = pick(TRADE_STATUSES, ['N_A', SUSPECTED_TRADE_STATUS]);

    return includes(canApplyStatuses, tradeStatus);
};

const getPromptCount = () => localStorage.getItem(COUNT_TOKEN) || 0;

export function doPostAuthAtLogin(dateRegistered, tradeStatus) {
    if (dateRegistered > CUTOFF_DATE && tradeStatus !== SUSPECTED_TRADE_STATUS) {
        return false;
    }

    if (localStorage.getItem(COMPLETED_TOKEN) === true) {
        return false;
    }

    if (!canApplyForTrade(tradeStatus)) {
        return false;
    }

    return getPromptCount() < MAX_PROMPT_INFO_COUNT;
};

export function incrementLoginPromptCount() {
    const currentCount = getPromptCount();
    const newCount = currentCount + 1;
    localStorage.setItem(COUNT_TOKEN, newCount);
};

export function markCompletedInLocalStorage() {
    localStorage.setItem(COMPLETED_TOKEN, true);
}



// WEBPACK FOOTER //
// ./assets/js/postAuth/promptTracker.es.js